module.exports = __webpack_public_path__ + "img/discover.10f206d2.svg";